import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Input, Row } from 'reactstrap';
import useFormatMessage from '../../../utils/useFormatMessage';

const GirisCikisTarihleri = ({ data, adress_data }) => {
    const { t } = useFormatMessage();
    const initialState = {
        turkiye_giris: "",
        turkiye_cikis: "",
        fikfit_giris: "",
        fikfit_cikis: "",
        son_depo_giris: "",
        son_depo_cikis: ""
    };

    const [dataSource, setDataSource] = useState(initialState);

    const formatDate = (date) => {
        try {
            return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
        } catch (error) {
            console.warn("Date formatting error:", error);
            return "";
        }
    };

    const isNotWarehouse = (movementName) => {
        const nonWarehouseNames = ['GEMİ', 'DEPO İADE', 'BAYİ DEPO İADE', 'FABRİKA'];
        return nonWarehouseNames.some(name => movementName.includes(name));
    };

    const isWarehouseEntry = (operation) => {
        return operation === "DEPO GİRİŞ" ||
            operation === "GEMİ TAHLİYE" ||
            operation === "İADE OKUTMASI" ||
            operation === "İADE GİRİŞİ";
    };

    const isWarehouseExit = (movement) => {
        const { movement_name = '', operation = '' } = movement;

        return movement_name.includes('TIR') ||
            operation === "KAPI ÇIKIŞ" ||
            operation === "KAPI ÇIKIŞ TARİHİ/TESLİM TARİHİ YÜKLEME";
    };

    useEffect(() => {
        try {
            if (!adress_data || !Array.isArray(adress_data)) {
                setDataSource(initialState);
                return;
            }

            let lastWarehouseEntry = "";
            let lastWarehouseExit = "";
            let lastExitDate = null;

            // Process movements in chronological order
            const sortedMovements = [...adress_data].sort((a, b) =>
                new Date(a.process_date) - new Date(b.process_date)
            );

            sortedMovements.forEach(movement => {
                if (!movement) return;

                const movementName = movement.movement_name || '';

                if (isNotWarehouse(movementName)) {
                    return;
                }

                if (isWarehouseEntry(movement.operation)) {
                    lastWarehouseEntry = movement.process_date;
                }

                if (isWarehouseExit(movement)) {
                    const currentExitDate = new Date(movement.process_date);
                    if (!lastExitDate || currentExitDate > lastExitDate) {
                        lastWarehouseExit = movement.process_date;
                        lastExitDate = currentExitDate;
                    }
                }
            });

            // Find gumruk and tahliye operations
            const tahliyeOp = sortedMovements.find(op => op.operation === "GEMİ TAHLİYE");
            const gumrukOp = data.find(op => op.operation === "GÜMRÜK İŞLEMİ");

            setDataSource({
                ...initialState,
                turkiye_giris: formatDate(tahliyeOp?.process_date),
                fikfit_giris: formatDate(gumrukOp?.process_date),
                son_depo_giris: formatDate(lastWarehouseEntry),
                son_depo_cikis: formatDate(lastWarehouseExit)
            });
        } catch (error) {
            console.error("Error processing data:", error);
            setDataSource(initialState);
        }
    }, [data, adress_data]);

    const renderInput = (label, value) => (
        <Col lg="6">
            <div className="dx-fieldset p-0">
                <div className="dx-field mb-2 row">
                    <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                        {t(label)}
                    </div>
                    <div className="dx-field-value col-md-8">
                        <Input
                            id={`input-${label.toLowerCase().replace(/\s+/g, '-')}`}
                            disabled
                            value={value || ""}
                        />
                    </div>
                </div>
            </div>
        </Col>
    );

    return (
        <Row>
            {renderInput("Türkiye Liman Giriş", dataSource.turkiye_giris)}
            {renderInput("Türkiye Liman Çıkış", dataSource.turkiye_cikis)}
            {renderInput("Fiktif Giriş", dataSource.fikfit_giris)}
            {renderInput("Fiktif Çıkış", dataSource.fikfit_cikis)}
            {renderInput("Son Depo Giriş", dataSource.son_depo_giris)}
            {renderInput("Son Depo Çıkış", dataSource.son_depo_cikis)}
        </Row>
    );
};

export default GirisCikisTarihleri;